__turbopack_context__.v({
  "author": "quoted-tweet-header-module__Cx2l9W__author",
  "authorText": "quoted-tweet-header-module__Cx2l9W__authorText",
  "avatar": "quoted-tweet-header-module__Cx2l9W__avatar",
  "avatarSquare": "quoted-tweet-header-module__Cx2l9W__avatarSquare",
  "header": "quoted-tweet-header-module__Cx2l9W__header",
  "username": "quoted-tweet-header-module__Cx2l9W__username",
});
